export class Country {
    constructor(
        public isoCode: string,
        public name: string,
        public nationality: string,
        public countryCode: string
    ){}
}
